
export default async () => {
    let holders = $( '.house-types__holder' );
    let lists = holders.children( '.house-types__list' );

    lists.hide();

    $( '.card-house-list' ).on( 'click', function ( e ) {
        e.preventDefault();

        let holder = $( this ).parents( '.house-types__holder' ).first();
        let list = $( this ).parents( '.house-types__holder' ).first().children( '.house-types__list' );

        if ( holder.hasClass( 'active' ) ) {
            holder.removeClass( 'active' );
        } else {
            holder.addClass( 'active' );
        }

        let otherHolders = holders.not( holder );
        let otherLists = otherHolders.children( '.house-types__list' );

        otherHolders.removeClass( 'active' );
        otherLists.slideUp();

        if ( holder.hasClass( 'active' ) ) {
            list.slideDown();
        } else {
            list.slideUp();
        }

        return false;
    } );
};
